import Backbone from 'backbone';
import apiUrlMethodsDescriptor from '../apiUrlMethods';

Object.defineProperties(
	Backbone.Collection.prototype,
	apiUrlMethodsDescriptor
);